import {z} from '@hono/zod-openapi';

export const jsonValueSchema: z.ZodType<unknown> = z
  .lazy(() =>
    z.union([
      z.string(),
      z.number(),
      z.boolean(),
      z.null(),
      z.array(jsonValueSchema),
      z.record(jsonValueSchema),
    ])
  )
  .openapi({
    type: 'object',
    additionalProperties: true,
    description: 'Arbitrary JSON value used for advertising payloads and credentials.',
  });

export const advertisementPayloadSchema = z.record(jsonValueSchema).openapi({
  type: 'object',
  additionalProperties: true,
  description: 'Arbitrary advertising payload keyed by source field name.',
});

export type AdvertisementPayload = z.infer<typeof advertisementPayloadSchema>;
